import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const Minus: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M25.35 17.1667H6.68331c-.73333 0-1.33333-.6-1.33333-1.3334 0-.7333.6-1.3333 1.33333-1.3333H25.35c.7333 0 1.3333.6 1.3333 1.3333 0 .7334-.6 1.3334-1.3333 1.3334Z"
    />
  </Icon>
);
